export const DROPDOWN_PINS_SETTINGS_KEY = 'dropdownPins';

export const DROPDOWN_PIN_KEYS = {
  vehicleBodyType: 'vehicleBodyType',
  vehicleElectricBatteryType: 'vehicleElectricBatteryType',
  countries: 'countries',
  vehicleCategoryType: 'vehicleCategoryType',
  supplierType: 'supplierType',
  agentType: 'agentType',
  vehiclePowerPlantType: 'vehiclePowerPlantType',
  fuelLevel: 'fuelLevel',
  transactionType: 'transactionType',
  transactionRecordCategory: 'transactionRecordCategory',
} as const;

export type DropdownPinPreferences = Record<string, (string | number)[]>;

export function parseDropdownPinPreferences(
  raw: unknown,
): DropdownPinPreferences {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }

  const preferences: DropdownPinPreferences = {};
  for (const [key, value] of Object.entries(raw)) {
    if (!Array.isArray(value)) {
      continue;
    }
    preferences[key] = value.filter(
      (item): item is string | number =>
        typeof item === 'string' || typeof item === 'number',
    );
  }
  return preferences;
}
